/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import {
  Avatar,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Button,
  Snackbar,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { GrTrash } from '@react-icons/all-files/gr/GrTrash';
const { selectCurrentCountry } = Slices.profileSlice;
const { updateProductPayload } = Slices.tempCartSlice;
const { selectCountryValidations, getDecimalPoints } = Slices.configSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectDesktop } = Slices.appSlice;
import css from './index.module.scss';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper.js';
import { subProductsGA } from 'spwa-ui-library/esm/utils/helperGA.js';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { useLocation } from '@reach/router';
function ProductOptionStepper({
  productID,
  isSingleSelectionOption,
  disabled,
  option,
  menuCondiment,
  id,
  main,
  group,
  selectedProduct,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const intl = useIntl();
  const [alertMessage, setAlertMessage] = useState('');
  const isDesktop = useSelector(selectDesktop);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const decimalPoints = useSelector(getDecimalPoints);
  const tempItems = useSelector((state) => state.tempCart);
  const productsMap = useSelector(selectProductEntities);

  const locationSearch = new URLSearchParams(location.search);
  let isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product');
  let stepId = locationSearch.get('step');

  const mainProductInfo = productsMap[isBundleItem ? mainProductId : productID];

  if (mainProductInfo?.bundleTypeId == 'bundle' && mainProductInfo?.typeId == 'simple') {
    stepId = mainProductInfo?.steps[0]?.id || 1;
  }

  const productCustomization = tempItems.data?.items?.find(
    (product) => product.id == ((isBundleItem ? mainProductId : productID))
  );

  let variationArray = [-1, -1, -1];
  let currentProductVariation;

  if (!isBundleItem) {
    // eslint-disable-next-line no-unused-expressions
    Object.values(productCustomization?.variants || {})?.forEach((variant, index) => {
      variationArray[index] = variant;
    });

    currentProductVariation = productsMap[productID]?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });

    currentProductVariation = productsMap[productID]?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  } else {
    const stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
    const productInfo = stepInfo?.options?.find((option) => option?.id == productID);

    if (productCustomization?.bundle?.[stepId]?.[productID]?.variants) {
      Object.values(productCustomization?.bundle?.[stepId]?.[productID]?.variants).forEach(
        (variant, index) => {
          variationArray[index] = variant;
        }
      );
    } else {
      Object.values(productInfo?.variants || {}).forEach((variant, index) => {
        const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
        if (selectedOption) {
          variationArray[index] = selectedOption?.id;
        }
      });
    }

    currentProductVariation = productInfo?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  }
  if (!currentProductVariation) {
    currentProductVariation = productsMap[productID];
  }

  const simpleBundleStepOption = currentProductVariation?.steps
    ?.find((s) => s?.id == stepId)
    ?.options?.find((o) => o?.id == option?.id);

  // REDUCE STEPPER QUANTITY
  const reduce = () => {
    console.log(`inside reduce`);
    let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));
    let product;
    if (isBundleItem) {
      product = newProductCustomization['bundle'][stepId][productID];
    } else {
      if (
        currentProductVariation?.bundleTypeId == 'bundle' &&
        currentProductVariation?.typeId == 'simple'
      ) {
        product = newProductCustomization['bundle'][stepId][option?.id];
      } else {
        product = newProductCustomization;
      }
    }

    if (!product?.items) {
      product['items'] = {};
    }

    if (!product.items[group?.id]) {
      product.items[group?.id] = {};
    }
    if (!product.items[group?.id][option.id]) {
      product.items[group?.id][option.id] = {};
    }

    product.items[group?.id][option.id]['qty'] =
      (product.items[group?.id][option.id]?.qty || 1) - 1;

    if (product.items[group?.id][option.id]['qty'] == 0) {
      delete product.items[group?.id][option.id];
    }

    if (isBundleItem) {
      newProductCustomization['bundle'][stepId][productID] = product;
    } else {
      if (
        currentProductVariation?.bundleTypeId == 'bundle' &&
        currentProductVariation?.typeId == 'simple'
      ) {
        delete newProductCustomization['bundle'][stepId][option?.id];
        if (simpleBundleStepOption?.price) {
          newProductCustomization['price'] = newProductCustomization['price']
            ? newProductCustomization['price'] - simpleBundleStepOption?.price
            : 0;
        }
      } else {
        newProductCustomization = product;
      }
    }
    if (option.default) {
      if (!newProductCustomization.removed) {
        newProductCustomization.removed = {};
        newProductCustomization.removed[option.id] = option.title;
      } else {
        newProductCustomization.removed[option.id] = option.title;
      }
      if (newProductCustomization.added) {
        delete newProductCustomization.added[option.id];
      }
    } else {
      if (newProductCustomization.added) {
        delete newProductCustomization.added[option.id];
      }
    }

    dispatch(
      updateProductPayload({
        data: newProductCustomization,
      })
    );
  };

  // INCREASE STEPPER QUANTITY
  const increase = (id) => {
    const newOption = { ...option, selectionQty: option.selectionQty + 1 };
    let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));
    let product;
    if (isBundleItem) {
      product = newProductCustomization['bundle']?.[stepId]?.[productID];
    } else {
      if (
        currentProductVariation?.bundleTypeId == 'bundle' &&
        currentProductVariation?.typeId == 'simple'
      ) {
        product = newProductCustomization['bundle']?.[stepId]?.[option?.id];
      } else {
        product = newProductCustomization;
      }
    }

    if (!product?.items) {
      product = product || {};
      product['items'] = {};
    }

    if (!product.items[group?.id]) {
      product.items[group?.id] = {};
    }
    if (!product.items[group?.id][option.id]) {
      product.items[group?.id][option.id] = {};
    }

    product.items[group?.id][option.id]['qty'] =
      (product.items[group?.id][option.id]?.qty || 0) + 1;

    let total = 0;
    if (
      currentProductVariation?.bundleTypeId == 'bundle' &&
      currentProductVariation?.typeId == 'simple'
    ) {
      for (let option of Object.values(newProductCustomization['bundle']?.[stepId] || {})) {
        total += option?.qty || 0;
      }
      total += 1;
    } else {
      for (let option of Object.values(product.items[group?.id] || {})) {
        total += option?.qty || 0;
      }
    }

    if (group.maximum < total) {
      setAlertMessage(
        intl.formatMessage(
          {
            id: group.maximum
              ? 'max_quantity_allowed_for_sauces'
              : 'max_quantity_allowed_for_this_step',
          },
          { count: group?.maximum }
        )
      );
    } else {
      if (isBundleItem) {
        newProductCustomization['bundle'][stepId][productID] = product;
      } else {
        if (
          currentProductVariation?.bundleTypeId == 'bundle' &&
          currentProductVariation?.typeId == 'simple'
        ) {
          console.log(`newProductCustomization -- `, newProductCustomization);
          newProductCustomization['bundle'][stepId][option?.id] = { qty: 1 };
          if (simpleBundleStepOption?.price) {
            newProductCustomization['price'] = newProductCustomization['price']
              ? newProductCustomization['price'] + simpleBundleStepOption?.price
              : simpleBundleStepOption?.price;
          }
        } else {
          newProductCustomization = product;
        }
      }
      if (!option.default) {
        if (!newProductCustomization.added) {
          newProductCustomization.added = {};
          newProductCustomization.added[option.id] = option.title;
        } else {
          newProductCustomization.added[option.id] = option.title;
        }
      } else {
        if (newProductCustomization.removed) {
          delete newProductCustomization.removed[option.id];
        }
      }

      dispatch(
        updateProductPayload({
          data: newProductCustomization,
        })
      );
      subProductsGA(newOption.name, selectedProduct.name);
    }
  };

  const optionName = option && option?.title;
  const imgUrl = option?.assets[0]?.src;

  const handleAlertClose = (event, reason) => {
    setAlertMessage('');
  };

  let qty = 0;
  if (isBundleItem) {
    qty =
      productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[group.id]?.[option.id]?.['qty'] || 0;
  } else {
    if (
      currentProductVariation?.bundleTypeId == 'bundle' &&
      currentProductVariation?.typeId == 'simple'
    ) {
      qty = productCustomization?.['bundle']?.[stepId]?.[option.id]?.['qty'];
    } else {
      qty = productCustomization?.['items']?.[group?.id]?.[option.id]?.['qty'];
    }
  }

  return (
    <>
      <ListItem button component="label" htmlFor={id} ContainerProps={{ className: css.root }}>
        <Avatar variant="square" alt={optionName} src={`${imgUrl}`} className={css.image} />
        <div className={css.title}>
          <ListItemText primary={`${optionName}`} />
          {option?.default == 1 && (
            <div className={css.defaultSpan}>
              <FormattedMessage id={'default'} defaultMessage={'DEFAULT'} />
            </div>
          )}
          <ListItemText
            className={css.priceSpan}
            primary={`${
              option?.price
                ? '( ' +
                  decimalChecker(option?.price, decimalPoints) +
                  ' ' +
                  countryValidations.currency +
                  ')'
                : ''
            }`}
          />
        </div>
        <ListItemSecondaryAction className={css.actionButton}>
          <div className={classNames(css.addToCart, { [css.flexEnd]: isSingleSelectionOption })}>
            {!(isBundleItem
              ? productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[group.id]?.[
                  option.id
                ]?.['qty']
              : (
                (currentProductVariation?.bundleTypeId == 'bundle' && currentProductVariation?.typeId == 'simple')
                  ? productCustomization?.['bundle']?.[stepId]?.[option.id]?.['qty']
                  : productCustomization?.['items']?.[group?.id]?.[option.id]?.['qty'])
              ) ? (
              <Button
                variant="outlined"
                color="info"
                size="medium"
                fullWidth
                className={css.add}
                onClick={(e) => increase(id)}
              >
                <FormattedMessage id="producttile_add" defaultMessage="Add" />
              </Button>
            ) : (
              <>
                <Button variant="outlined" className={css.less} onClick={(e) => reduce()}>
                  {(isBundleItem
                    ? productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[
                        group.id
                      ]?.[option.id]?.['qty']
                    : ((currentProductVariation?.bundleTypeId == 'bundle' && currentProductVariation?.typeId == 'simple')
                       ? productCustomization?.['bundle']?.[stepId]?.[option.id]?.['qty']
                       : productCustomization['items']?.[group?.id]?.[option.id]?.['qty']
                    )) == 1 ? (
                    <GrTrash />
                  ) : (
                    '-'
                  )}
                </Button>
                {!isSingleSelectionOption && (
                  <>
                    <Button className={css.value}>{qty}</Button>
                    <Button variant="outlined" className={css.plus} onClick={(e) => increase(id)}>
                      +
                    </Button>
                  </>
                )}
              </>
            )}
          </div>
        </ListItemSecondaryAction>
      </ListItem>
      {alertMessage && isDesktop && (
        <Snackbar
          open={alertMessage?.length > 0}
          autoHideDuration={6000}
          onClose={handleAlertClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={handleAlertClose} severity="error" sx={{ width: '100%' }}>
            {alertMessage}
          </Alert>
        </Snackbar>
      )}
      {alertMessage && !isDesktop && (
        <div onClick={handleAlertClose} className={css.alert}>
          {alertMessage}
        </div>
      )}
    </>
  );
}

export default ProductOptionStepper;
